import { Sprite, Texture, Point, Container } from 'pixi.js';
import { SpineAnimation } from '@cc/pixi-app';
import { app } from './../app';
import { session } from './../session';
import { Player } from './../common/Player';


export class EntityStatic extends Container {
    constructor(id, textureId, tileX, tileY) {
        super();

        this.id = id;
        this.tilePos = new Point(tileX, tileY);
        this.isAnim = false;

        this.sprite = new Sprite.from(Texture.from(textureId) || Texture.EMPTY);
        this.sprite.anchor.set(0.5);
        this.addChild(this.sprite);
    }

    setOffset(offset) {
        this.sprite.position.copyFrom(offset);
    }

    destroy() {
        if (this.bubble) this.bubble.destroy();
    }
}

export class EntityAnim extends Container {
    constructor(id, spineData, tileX, tileY) {
        super();

        this.id = id;
        this.data = spineData;
        this.tilePos = new Point(tileX, tileY);
        this.isAnim = true;

        this.isMoving = false;
        this.history = [];
        this.goneBack = false;
        this.moveDistance = 64;
        this.baseMoveTime = 250;
        this.moveTime = this.baseMoveTime / this.data.speed;

        this.anims = new Container();
        this.addChild(this.anims);

        if (!this.data.idleAnim) this.data.idleAnim = 'idle';
        if (!this.data.moveAnim) this.data.moveAnim = 'move';

        if (this.data.turnarounds) {
            this.hasTurnarounds = true;

            this.poses = new Map();
            Object.keys(this.data.turnarounds).forEach(key => {
                let anim;
                anim = new SpineAnimation(this.data.turnarounds[key]);
                anim.setAnimation(0, this.data.initAnim, true);
                anim.setDefaultMix(0.2);
                anim.scale.set(this.data.scale);
                anim.visible = false;
                this.anims.addChild(anim);
                this.poses.set(key.toUpperCase(), anim);
            });

            this.currPose = this.poses.get(this.data.initPose.toUpperCase());
            this.moveDirection = this.data.initPose.toUpperCase();
            this.currPose.visible = true;

        } else {
            this.hasTurnarounds = false;
            this.spine = new SpineAnimation(this.data.name);
            this.spine.setSkinByName(this.data.skin);
            this.spine.setAnimation(0, this.data.initAnim, true);
            this.spine.setDefaultMix(0.2);
            this.spine.scale.set(this.data.scale);
            this.anims.addChild(this.spine);

            this.currPose = this.spine;
        }
    }

    setDirection(direction) {
        var pose = this.poses.get(direction);

        if (pose !== this.currPose) {
            pose.visible = true;
            this.currPose.visible = false;
            this.currPose = pose;
        }
    }

    calculateDirection(moveDelta) {
        let direction = this.moveDirection;

        if (moveDelta.y < 0) direction = Player.direction.up;
        else if (moveDelta.y > 0) direction = Player.direction.down;
        else if (moveDelta.x < 0) direction = Player.direction.left;
        else if (moveDelta.x > 0) direction = Player.direction.right;

        if (direction !== this.moveDirection) this.hasDirectionChanged = true;
        return direction;
    }

    moveTo(tilePos) {
        this.moveDelta = tilePos;
        this.moveDirection = this.calculateDirection(this.moveDelta);
        this.setDirection(this.moveDirection);

        this.isMoving = true;

        this.tilePos.x += this.moveDelta.x;
        this.tilePos.y += this.moveDelta.y;

        let moveX = this.moveDelta.x * this.moveDistance;
        let moveY = this.moveDelta.y * this.moveDistance;

        app.tween(this)
            .to({ x: this.x + moveX, y: this.y + moveY }, this.moveTime, createjs.Ease.linear)
            .call(() => this.shouldMoveAgain());
    }

    shouldMoveAgain() {
        this.stopMoving();

/*         if (this.target && this.target.path.length <= 0) this.stopMoving();

        this.moveTo()

        if (this.autoMoving) {
            if (this.inputBuffer.length <= 0) this.stopMoving();
            else {
                let posDelta = this.inputBuffer.shift();
                this.moveDirection = this.calculateDirection(posDelta);
                this.tryMove(posDelta);
            }
        } else if (this.moveDelta.x !== 0 || this.moveDelta.y !== 0) {
            this.tryMove(this.moveDelta);
        } else {
            this.stopMoving();
        } */
    }

    stopMoving() {
        this.isMoving = false;
        this.playAnim(this.data.idleAnim, true);
    }

    playAnim(anim, shouldLoop) {
        if (!this.currPose) return;

        this.currPose.setAnimation(0, anim, shouldLoop);
    }

    setOffset(offset) {
        let offsetX = offset.x + this.data.offset.x;
        let offsetY = offset.y + this.data.offset.y;
        this.anims.position.set(offsetX, offsetY);
    }

    addEvents(events) {
        this.currPose.spine.state.addListener(events);
    }

    clearListeners() {
        this.currPose.spine.state.clearListeners();
    }
}
